const getThumbnailHeight = (isVertical: boolean) => (isVertical ? 100 : 80);

export default getThumbnailHeight;
